import React from 'react'
import { Box, Flex, Text } from '@chilipiper/design-system'
import chiliPiperAnimatedLogo from '../extension/images/chiliPiperAnimatedLogo.svg'

export const FinishingOnboarding = () => (
  <Flex
    w='100%'
    h='100%'
    bg='bg/minor'
    flexDirection='column'
    alignItems='center'
    justifyContent='center'
    gap={8}
  >
    <Box
      as='img'
      className='chromatic-ignore'
      src={chiliPiperAnimatedLogo}
      alt='chili piper logo loader'
      w={12}
      h={12}
    />
    <Text textStyle='page-section-heading' color='fg/moderate'>
      Spicing up your account...
    </Text>
  </Flex>
)
